"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphicFormatter = graphicFormatter;
exports.pieFormatter = pieFormatter;
exports.mapFormatter = mapFormatter;
exports.barFormatter = void 0;

var defaultValueFormatter = function defaultValueFormatter(x) {
  return x;
};

var numberToString = function numberToString(num) {
  return Number(num).toFixed(2).replace(/(0+)$/, '').replace(/\.$/, '');
};

var getFormattedValue = function getFormattedValue(value, tooltipOptions) {
  var stringValue = !isNaN(value) ? numberToString(value) : value;

  if (!tooltipOptions) {
    return stringValue;
  }

  var valueFormatter = tooltipOptions.valueFormatter ? tooltipOptions.valueFormatter : defaultValueFormatter;
  return (tooltipOptions.valuePrefix || '') + valueFormatter(stringValue) + (tooltipOptions.valueSuffix || '');
};

function graphicFormatter() {
  return "\n    <table>\n      <tr class=\"highcharts-header\"><th>".concat(this.x, "</th></tr>\n      ").concat(this.points.reduce(function (acc, point) {
    return "".concat(acc, "\n          <tr>\n            <td>\n              <span class=\"highcharts-color-").concat(point.colorIndex, "\">\u25CF</span>\n              <b>").concat(point.series.name, "</b>\n              <!-- Add space between name and value\n                   values will be outside tooltip box if using padding -->\n              &nbsp;&nbsp;\n            </td>\n            <td class=\"highcharts-tooltip-value\">").concat(getFormattedValue(point.y, point.series.tooltipOptions), "</td>\n          </tr>\n          ");
  }, ''), "\n    </table>\n  ");
}

function singleBarFormatter(tooltip) {
  var point = this.points[0];
  var percentage = this.y / tooltip.options.total * 100;
  return "\n    <table>\n      <tr class=\"highcharts-header\"><th>".concat(tooltip.options.header, "</th></tr>\n      <tr>\n        <td><b>").concat(this.x, "&nbsp;&nbsp;</b></td>\n      </tr>\n      <tr>\n        <td class=\"highcharts-tooltip-value highcharts-tooltip-value--single\">\n          <span class=\"highcharts-color-0\">\u25CF</span>\n          ").concat(getFormattedValue(point.y, tooltip.options), "\n          <span class=\"highcharts-tooltip-gray\">\n            (").concat(Number(percentage).toFixed(2), "%)\n          </span>\n        </td>\n      </tr>\n    </table>\n  ");
}

function multipleBarFormatter(tooltip) {
  var total = this.points.reduce(function (acc, point) {
    return acc + point.y;
  }, 0);
  return "\n    <table>\n      <tr class=\"highcharts-header\"><th>".concat(tooltip.options.header, "</th></tr>\n      <tr>\n        <td><b>").concat(this.x, "&nbsp;&nbsp;</b></td>\n        <td class=\"highcharts-tooltip-value\"><b>").concat(getFormattedValue(total, tooltip.options), "</b></td>\n      </tr>\n      ").concat(this.points.reduce(function (acc, point) {
    return "".concat(acc, "\n          <tr>\n            <td>\n              <span class=\"highcharts-color-").concat(point.colorIndex, "\">\u25CF</span>\n              ").concat(point.series.name, "\n              <!-- Add space between name and value\n                   values will be outside tooltip box if using padding -->\n              &nbsp;&nbsp;\n            </td>\n            <td class=\"highcharts-tooltip-value\">").concat(getFormattedValue(point.y, point.series.tooltipOptions), "</td>\n          </tr>\n          ");
  }, ''), "\n    </table>\n  ");
}

var barFormatter = function barFormatter(tooltip) {
  var isSingleData = this.points.length === 1;
  return isSingleData ? singleBarFormatter.call(this, tooltip) : multipleBarFormatter.call(this, tooltip);
};

exports.barFormatter = barFormatter;

function pieFormatter() {
  return "\n    <table>\n      <tr class=\"highcharts-header\"><th>".concat(this.series.name, "</th></tr>\n      <tr>\n        <td>\n          <span class=\"highcharts-color-").concat(this.colorIndex, "\">\u25CF</span>\n          <b>").concat(this.key, "</b>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          ").concat(getFormattedValue(this.point.y, this.series.tooltipOptions), "\n          <span class=\"highcharts-tooltip-gray\">\n            (").concat(Number(this.point.percentage).toFixed(2), "%)\n          </span>\n        </td>\n      </tr>\n    </table>\n  ");
}

function mapFormatter(tooltip) {
  return "\n    <table>\n      <tr class=\"highcharts-header\">\n        <th colspan=\"2\">".concat(tooltip.options.header, "</th>\n      </tr>\n      <tr>\n        <td>\n          <span class=\"highcharts-color-0\">\u25CF</span>\n          <b>").concat(this.point.options.name || this.key, "</b>\n          &nbsp;&nbsp;\n        </td>\n        <td class=\"highcharts-tooltip-value\">").concat(getFormattedValue(this.point.value, tooltip.options), "</td>\n      </tr>\n    </table>\n  ");
}